import React, { useEffect, useRef, useState } from "react";

const stats = [
  { value: 42, suffix: "M+", label: "Total Capital Deployed" },
  { value: 14.2, suffix: "%", label: "Average Annual Return" },
  { value: 28, suffix: "", label: "Successful Projects" },
  { value: 650, suffix: "+", label: "Satisfied Investors" },
];

const Counter = ({ target, suffix, isVisible }) => {
  const [count, setCount] = useState(0);
  const duration = 2000; // animation duration in ms

  useEffect(() => {
    if (!isVisible) return;

    let start = 0;
    const end = target;
    const startTime = performance.now();

    const updateCounter = (currentTime) => {
      const elapsed = currentTime - startTime;
      if (elapsed < duration) {
        const progress = Math.min(elapsed / duration, 1);
        const value = Math.floor(progress * end);
        setCount(value);
        requestAnimationFrame(updateCounter);
      } else {
        setCount(end);
      }
    };

    requestAnimationFrame(updateCounter);
  }, [isVisible, target]);

  return (
    <span>
      {count.toLocaleString()}
      {suffix}
    </span>
  );
};

const StatsSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);

  return (
    <div
      ref={sectionRef}
      className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 text-center tracking-wide"
    >
      {stats.map((stat, index) => (
        <div
          key={index}
          className={`transition-all duration-500 ${
            isVisible ? "transform -translate-y-1" : ""
          }`}
        >
          <div className="text-4xl md:text-5xl font-bold text-primary">
            <Counter target={stat.value} suffix={stat.suffix} isVisible={isVisible} />
          </div>
          <p className="text-gray-600 mt-6 text-lg">{stat.label}</p>
        </div>
      ))}
    </div>
  );
};

export default StatsSection;
